import LayoutContainer from 'components/Common/LayoutContainer'
import React, { useReducer } from 'react'
import styled from 'styled-components'
import BusinessTravellerSignupBusinessExists from './steps/BusinessTravellerSignupBusinessExists'
import BusinessTravellerSignupEmailValidation from './steps/BusinessTravellerSignupEmailValidation'
import BusinessTravellerSignupCreateBusiness from './steps/BusinessTravellerSignupCreateBusiness'
import BusinessTravellerSignupLinkAccount from './steps/BusinessTravellerSignupLinkAccount'
import BusinessTravellerSignupCreateCustomer from './steps/BusinessTravellerSignupCreateCustomer'
import {
  BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS,
  BusinessTravellerBusinessOnboardingDispatchContext,
  BusinessTravellerBusinessOnboardingStateContext,
  businessTravellerBusinessOnboardingStateReducer,
} from 'businessTraveller/contexts/BusinessTravellerBusinessOnboardingContexts'

const SignupContainer = styled(LayoutContainer)`
  padding: 0;
`

const steps: App.BusinessTraveller.BusinessSignupSteps = [{
  label: 'Email address',
  stepKey: 'validate_email',
}, {
  label: 'Create password',
  stepKey: 'create_customer',
}, {
  label: 'Account details',
  stepKey: 'create_business',
}]

function BusinessTravellerBusinessSignupStepper() {
  const [accountSetupState, accountSetupDispatch] =
    useReducer(businessTravellerBusinessOnboardingStateReducer, {
      step: BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.VALIDATE_EMAIL,
      businessName: '',
      adminEmail: '',
    })
  const { step } = accountSetupState

  return (
    <SignupContainer>
      <BusinessTravellerBusinessOnboardingStateContext.Provider value={accountSetupState}>
        <BusinessTravellerBusinessOnboardingDispatchContext.Provider value={accountSetupDispatch}>
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.VALIDATE_EMAIL &&
            <BusinessTravellerSignupEmailValidation steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.CREATE_CUSTOMER &&
            <BusinessTravellerSignupCreateCustomer steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.LINK_ACCOUNT &&
            <BusinessTravellerSignupLinkAccount steps={steps} />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.BUSINESS_EXISTS &&
            <BusinessTravellerSignupBusinessExists />}
          {step === BUSINESS_TRAVELLER_BUSINESS_ONBOARDING_STEPS.CREATE_BUSINESS &&
            <BusinessTravellerSignupCreateBusiness steps={steps} />}
        </BusinessTravellerBusinessOnboardingDispatchContext.Provider>
      </BusinessTravellerBusinessOnboardingStateContext.Provider>
    </SignupContainer>
  )
}

export default BusinessTravellerBusinessSignupStepper
